import * as types from "./actionTypes";

export const uploadDocumentation = (document) => ({
  type: types.DOCUMENTATION_INITIATE_UPLOAD,
  payload: document,
});

export const documentationSuccess = (result) => ({
  type: types.DOCUMENTATION_SUCCESS,
  payload: result,
});

export const documentationError = (err) => ({
  type: types.DOCUMENTATION_ERROR,
  payload: err,
});
